import React from "react";
import "./Stepper.css";

const Stepper = ({ steps }) => {
  return (
    <div className="timeline-container">
      {steps.map((step, index) => (
        <div
          key={index}
          className={`timeline-row ${index % 2 === 0 ? "left" : "right"}`}
        >
          {/* Step Dot */}
          <div className="step-dot" />

          {/* Card */}
          <div className="step-card">
            <h3 className="step-title">{step.title}</h3>
            <p className="step-org">{step.org}</p>
            <p className="step-date">{step.date}</p>

            <ul>
              {step.points.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Stepper;
